import { render } from "./headset-mic-icon.vue?vue&type=template&id=6cb5aa51"
import script from "./headset-mic-icon.vue?vue&type=script&lang=js"
export * from "./headset-mic-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__